import { useCallback, useEffect, useState } from 'react';
import moment from 'moment-jalaali';

const useForms = (initialState) => {
  const [theForm, settheForm] = useState(initialState);
  const [formIsValid, setformIsValid] = useState(false);
  const [Message, setMessage] = useState({ message: '', type: 'error' });

  const clearAll = useCallback(
    (resetValue) => {
      settheForm(resetValue);
      setformIsValid(false);
      setMessage({ message: '', type: 'error' });
    },
    [settheForm, setformIsValid, setMessage]
  );

  const checkValidity = useCallback((value, rules) => {
    if (!rules) {
      return -1;
    }

    if (rules.required && value.trim() === '') {
      // return 'required';
      return 'نباید خالی باشد';
    }

    if (rules.minLength && value.length < rules.minLength) {
      // return 'minLength';
      return `باید حداقل ${rules.minLength} حرف باشد`;
    }

    // if (rules.maxLength) {
    //   isValid = value.length <= rules.maxLength && isValid;
    // }

    // if (rules.isEmail) {
    //   const pattern =
    //     /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    //   isValid = pattern.test(value) && isValid;
    // }

    if (rules.isNumeric && isNaN(value)) {
      // return 'isNumeric';
      return 'باید عدد باشد';
    }

    // if (rules.isNumeric) {
    //   const pattern = /^\d+$/;
    //   isValid = pattern.test(value) && isValid;
    // }

    // if (rules.isPhone) {
    //   const pattern = /^\d+$/;
    //   isValid =
    //     pattern.test(value) &&
    //     isValid &&
    //     value.length === 11 &&
    //     value.substring(0, 2) === '09';
    // }

    return -1;
  }, []);

  const findError = useCallback(
    (element, noMessage) => {
      switch (element.elementConfig.type) {
        case 'select':
          if (element.indexValue === -1) {
            if (noMessage) return true;
            setMessage({
              message: `فیلد "${element.elementConfig.placeholder}" را پر کنید`,
              type: 'error',
            });

            return true;
          } else if (element.AfterInputs) {
            let valid = false;
            element.AfterInputs[element.indexValue].forEach((e) => {
              valid = valid || findError(e, noMessage);
            });
            return valid;
          }
          return false;
        case 'text':
          if (!element.valid) {
            if (noMessage) return true;

            const errorMessage = checkValidity(element.value, element.validation);

            setMessage({
              message: `فیلد ${element.elementConfig.placeholder} ${errorMessage}`,
              type: 'error',
            });

            return true;
          }
          return false;

        case 'file':
          if (!element.valid) {
            if (noMessage) return true;

            setMessage({
              message: `فیلد "انتخاب فایل" نباید خالی باشد`,
              type: 'error',
            });

            return true;
          }
          return false;

        default:
          return false;
      }
    },
    [setMessage, checkValidity]
  );

  const findErrorAndShow = useCallback(() => {
    for (let i = 0; i < theForm.length; i++) {
      if (findError(theForm[i])) {
        return;
      }
    }
  }, [theForm, findError]);

  const onChangeHandlerRealFunction = useCallback(
    (newValueEvent, index, selectIndexValue, afterInputIndex) => {
      const allElements = [...theForm];
      let changedElement;

      if (afterInputIndex || afterInputIndex === 0) {
        changedElement = {
          ...theForm[index].AfterInputs[selectIndexValue][afterInputIndex],
        };
      } else {
        changedElement = { ...theForm[index] };
      }

      switch (changedElement.elementConfig.type) {
        case 'calendar':
          changedElement.value = newValueEvent;
          changedElement.requestValue = moment(newValueEvent).format('YYYY-MM-DD');

          break;
        case 'file':
          const fileValue = newValueEvent.target.files[0];
          changedElement.value = fileValue;
          changedElement.valid = fileValue ? true : false;

          break;
        case 'select':
          const selectValue = newValueEvent.target.value;

          changedElement.value = selectValue;
          changedElement.indexValue = -1;

          changedElement.elementConfig.options.forEach((element, index) => {
            if (selectValue === element.value) {
              changedElement.indexValue = index;
              changedElement.requestValue = element.gainValue;
            }
          });

          break;
        case 'text':
        case 'password':
          const newValue = newValueEvent.target.value;

          changedElement.value = newValue;
          changedElement.valid = checkValidity(newValue, changedElement.validation) === -1 ? true : false;

          changedElement.touched = true;
          break;

        default:
          throw new Error('Should not be reached! -> forms hook');
      }

      if (afterInputIndex || afterInputIndex === 0) {
        allElements[index].AfterInputs[selectIndexValue][afterInputIndex] = changedElement;
      } else {
        allElements[index] = changedElement;
      }

      settheForm(allElements);

      setformIsValid(() => {
        for (let i = 0; i < allElements.length; i++) {
          if (findError(allElements[i], true)) {
            return false;
          }
        }
        return true;
      });
    },
    [theForm, settheForm, checkValidity, setformIsValid, findError]
  );

  const inputOnBlur = useCallback(
    (index, selectIndexValue, afterInputIndex) => {
      let theElement;
      if (afterInputIndex || afterInputIndex === 0) {
        theElement = theForm[index].AfterInputs[selectIndexValue][afterInputIndex];
      } else {
        theElement = theForm[index];
      }

      if (theElement.elementConfig.type === 'file') {
        return;
      }

      if (theElement.touched === false) {
        const allElements = [...theForm];

        if (afterInputIndex || afterInputIndex === 0) {
          allElements[index].AfterInputs[selectIndexValue][afterInputIndex].touched = true;
        } else {
          allElements[index].touched = true;
        }

        settheForm(allElements);
      }

      if (!theElement.valid) {
        const errorMessage = checkValidity(theElement.value, theElement.validation);

        setMessage({
          message: `فیلد ${theElement.elementConfig.placeholder} ${errorMessage}`,
          type: 'error',
        });
      }
    },
    [theForm, setMessage, settheForm, checkValidity]
  );

  useEffect(() => {
    if (Message.message === '') return;

    const timer = setTimeout(() => {
      setMessage({ message: '', type: 'error' });
    }, 3000);
    return () => {
      clearTimeout(timer);
    };
  }, [Message]);

  return {
    theForm: theForm,
    formIsValid: formIsValid,
    onChangeHandler: onChangeHandlerRealFunction,
    inputOnBlur: inputOnBlur,
    Message: Message,
    clearAll: clearAll,
    setMessage: setMessage,
    findErrorAndShow: findErrorAndShow,
    setformIsValid: setformIsValid,
  };
};

export default useForms;
